import React, {useEffect} from "react"
import {useNavigate} from "react-router-dom";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {useSearchParams} from 'react-router-dom';
import Typography from '@mui/material/Typography';

import { useTranslation } from 'react-i18next';

import useStore from "store/store";
import './ChooseAirline.scss'


export default function ChooseAirline(){
  const {t} = useTranslation();
  const navigate = useNavigate();
  
  let [, setSearchParams] = useSearchParams();

  let storeActions = useStore((state)=> state.actions);
  let airlines = useStore((state)=> state.airlines);
  const flightRecordAttempt = useStore((state)=> state.flightRecordAttempt);

  useEffect(()=>{
    if (!flightRecordAttempt.firstName || !flightRecordAttempt.lastName){
      navigate("/");
    }
  }, [flightRecordAttempt, navigate]);


  function handleChoosenAirline(airline){
    storeActions.setFlightRecordAttempt({ ...flightRecordAttempt, airline: airline });

    setSearchParams(params => {
      params.delete("chooseAirlinePanel");
      params.set("selectFlight", 1);
      return params;
    });
  }
              


  useEffect(()=>{
    storeActions.fetchAirlines();
  }, [storeActions]);


  return (
    <Box className="ca-container">

      <Typography variant="span" className="h5 font-1-heavy primary1-color">
        {t("Choose your airline: ")}
      </Typography>

      <div className="v-space-7"></div>

      <Grid container spacing={2}>
        {airlines.map((airline, key) => (
          <Grid item xs={6} sm={6} md={6} lg key={key} >
            <Box
              className={`img-btn bg-white-color`}
              onClick={()=>handleChoosenAirline(airline)}
              >
              <img src={require(`assets/images/airlines/${airline.name}.png`)} alt=""  />
            </Box>
          </Grid>
        ))}
      </Grid>

      <div className="v-space-7"></div>

      
      <div className="v-space-7"></div>

    </Box>
    )
}